import styled from '@emotion/styled';
import { Box } from '~Styles';

export const BoxWrapper = styled(Box)`
  width: 764px;
`;

export const StyledBox = styled(Box)<{ background?: string }>`
  background-color: ${({ background }) => background || 'var(--colorWhite)'};
  border-radius: 8px;
`;

export const StatBox = styled(Box)<{ borderColor?: string }>`
  padding: 8px 0;
  border-bottom: 1px solid ${({ borderColor }) => borderColor || 'var(--colorBlueGray200)'};
  &:last-child {
    border-bottom: none;
  }
`;

export const ActivityStatBox = styled(Box)`
  background: var(--colorBlueGray50);
  border-radius: 8px;
  white-space: nowrap;
`;
